import { FC } from 'react';
import { AdvertServiceDataType, RouterConfig } from '@edikk-edikk/country-frontend';
import { Link } from 'react-router';
import classNames from 'classnames';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import modelDetailParameterCss from '#advertDetail/assets/model-detail/model-detail-parameter.module.scss';

type PropsType = {
  serviceData: AdvertServiceDataType;
};

const ServiceLabel: FC<PropsType> = ({
  serviceData,
}) => {
  const {
    advert: {
      city,
    },
  } = useAdvertDetailContext();

  if (!serviceData.category) {
    return (
      <div className={modelDetailParameterCss.modelDetailParameter__label}>
        {serviceData.label}
      </div>
    );
  }

  return (
    <Link
      to={serviceData.category.url}
      state={{ routerConfig: RouterConfig.initForCategoryInCity(serviceData.category.id, city.id) }}
      className={classNames(
        modelDetailParameterCss.modelDetailParameter__label,
        modelDetailParameterCss.modelDetailParameter__label_asLink,
      )}
    >
      {serviceData.label}
    </Link>
  );
};

export { ServiceLabel };
